import { uniqBy } from 'lodash';
import moment from 'moment';

export default {
	month: state => state.month,
	ordenes: state => state.ordenes,
	totalOrdenes: state => state.totalOrdenes,
	totalGeneralOrdenes: state => state.totalGeneralOrdenes,
	kpisOrdenes: state => state.kpisOrdenes,
	conteosOrdenesPorMes: state => state.conteosOrdenesPorMes,
	loadingOrdenes: state => state.loadingOrdenes,
	errorOrdenes: state => state.errorOrdenes,
	filtroOrdenes: state => state.filtroOrdenes,
	getNotifyState: state => state.notifyState,
	lodgingsOfPerson: state => {
		const places = uniqBy(
			state.lodgingsOfPerson.map(lodging => lodging.place),
			'_id'
		);
		return places.map(place => ({
			...place,
			lodgings: state.lodgingsOfPerson.filter(lodging => lodging.place._id === place._id),
		}));
	},
	lodgingsOfPersons: state => state.lodgingsOfPerson,
	selectedService: state => state.selectedService,
	itemEmpty: state => state.itemEmpty,
	lodgingWithProblems: state => state.lodgingWithProblems,
	lodgings: state => {
		if (state.selectedPlace)
			return state.lodgings.filter(lod => lod.place == state.selectedPlace.value);
		else return state.lodgings;
	},
	allLodgings: state => {
		return state.lodgings;
	},
	bottomSheet: state => state.bottomSheet,
	message: state => state.message,
	lodgingPersons: state => state.lodgingPersons,
	updatingService: state => state.updatingService,
	mirrorLodging: state => state.mirrorLodging,
	lodgingSelect: state => state.lodgingSelect,
	loadingLodgings: state => state.loadingLodgings,
	editMode: state => state.editMode,
	rangeDatePayments: state => state.rangeDatePayments,
	lodgingsPlace: state => state.lodgingsPlace,
	countLogingsPlace: state => state.countLogingsPlace,
	rangeDate: state => state.rangeDate,
	periods: state => state.periods,
	regionSelecionada: state => state.regionSelecionada,
	places: state => state.places,
	placesFiltered: state => {
		let lugaresFiltrados = state.places;
		if (state.regionSelecionada)
			lugaresFiltrados = state.places.filter(place => {
				return place.region === state.regionSelecionada;
			});
		// si no hay lugares filtrados por defecto devolvemos todos
		// if (!lugaresFiltrados.length) lugaresFiltrados = state.places;

		return lugaresFiltrados.sort((placeA, placeB) => {
			let countDaysPerActivitiesA = 0;
			let countDaysPerActivitiesB = 0;
			state.lodgings.forEach(lod => {
				if (
					(lod.place == placeA._id &&
						moment(lod.start).isSameOrAfter(moment(), 'month')) ||
					(lod.place == placeA._id && moment(lod.end).isSameOrAfter(moment(), 'month'))
				)
					countDaysPerActivitiesA += 1;
				if (
					(lod.place == placeB._id &&
						moment(lod.start).isSameOrAfter(moment(), 'month')) ||
					(lod.place == placeB._id && moment(lod.end).isSameOrAfter(moment(), 'month'))
				)
					countDaysPerActivitiesB += 1;
			});
			return countDaysPerActivitiesB - countDaysPerActivitiesA;
		});
	},
	periodsTable: state => state.periods,
	selectedPlace: state => state.selectedPlace,
	servicesComboBox: state => state.servicesComboBox,
	startSave: state => state.startSave,
	updateMap: state => state.updateMap,
	notificationConfigurations: state => {
		return state.notificationConfigurations.reverse();
	},
	selectedNotificationConfig: state => state.selectedNotificationConfig,
	firma: state => state.firma,
	firmaTecnico: state => state.firmaTecnico,
	lodgingForm: state => state.lodgingForm,
};
